var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99917 8.99934L5.0045 12.994C4.8585 13.14 4.6805 13.25 4.4845 13.316L3.04917 13.796C2.52784 13.97 2.03184 13.4747 2.20517 12.9533L2.68317 11.5153C2.7485 11.3187 2.85917 11.1393 3.00584 10.9927L6.99917 6.99934M12.4465 5.54667L10.4465 3.54667M2.1665 2.16667L13.8332 13.8333M10.3898 7.72334L13.9185 4.19467C14.1792 3.934 14.1792 3.512 13.9185 3.252L12.8045 2.138C12.5438 1.87734 12.1218 1.87734 11.8618 2.138L8.33317 5.66667",
    stroke: "#23242A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEdit);
export default __webpack_public_path__ + "static/media/no-edit.2f35652b314fdc4bdb1b285292aff91c.svg";
export { ForwardRef as ReactComponent };